import React, { useCallback } from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import PictureWallStatus from "@radarly/components/widgets/picture-wall/status";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { DatavizPictureWall } from "@radarly/models/dataviz";
import { SearchFragmentPosts } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import PostsSort from "@radarly/shared/cards/subtitle/posts-sort";
import Tile from "@radarly/shared/cards/tile";
import PictureWall from "@radarly/shared/widgets/posts/picture-wall";
import { CardFragmentProps } from "../model";

const RadarlyPostsCardsPictureWall = ({
  title,
  fragment,
  project,
  height,
  openPostsPanel,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentProps<SearchFragmentPosts, DatavizPictureWall>) => {
  const locale = useCurrentUserLocale();
  const fullProject = useCurrentProject();

  const { from, to } = getDateFromClause(fragment.request.query);

  const onClickItem = useCallback(() => {
    openPostsPanel({
      clause: fragment.request.query,
      period: {
        from: from,
        to: to,
      },
      title: title,
      timezone,
      sortBy: fragment.request.pagination.sort.on,
    });
  }, [
    fragment.request.pagination.sort.on,
    fragment.request.query,
    from,
    openPostsPanel,
    timezone,
    title,
    to,
  ]);

  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <PostsSort fragment={fragment} />,
          ]}
        />
      }
      statusInfo={<PictureWallStatus project={fullProject} locale={locale} />}
      clause={fragment.request.query}
    >
      <PictureWall
        project={project.id}
        fragment={fragment}
        onClick={openPostsPanel ? onClickItem : null}
        forceReload={forceReload}
      />
    </Tile>
  );
};

export default RadarlyPostsCardsPictureWall;
